"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.flushTrackingObject = exports.getTrackingObject = exports.populateTrackingObjectFromUrl = exports.setTrackingObject = exports.urlSearchParamToTrackingObject = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var utmParameter_1 = require("../models/utmParameter");
var configuration_1 = require("../configuration");
var urlSearchParamToTrackingObject = function (params) {
    var trackingObject = {};
    // We need to handle ?source= because some of our affiliates are still using this
    var source = params.get('source');
    if (source !== null) {
        trackingObject.utm_source = source;
    }
    utmParameter_1.allUtmParameterKeys.forEach(function (key) {
        var value = params.get(key);
        if (value !== null) {
            trackingObject[key] = value;
        }
    });
    if (Object.keys(trackingObject).length === 0) {
        return undefined;
    }
    return trackingObject;
};
exports.urlSearchParamToTrackingObject = urlSearchParamToTrackingObject;
var setTrackingObject = function (obj) {
    var configuration = configuration_1.getConfiguration();
    js_cookie_1.default.set(configuration.featherInternalTrackingToolKey, JSON.stringify(obj), configuration.cookieAttributes);
};
exports.setTrackingObject = setTrackingObject;
var populateTrackingObjectFromUrl = function () {
    if (typeof window === 'undefined') {
        // Check if we're in browser
        return;
    }
    var params = new URLSearchParams(window.location.search);
    var trackingObject = exports.urlSearchParamToTrackingObject(params);
    if (trackingObject) {
        exports.setTrackingObject(trackingObject);
    }
};
exports.populateTrackingObjectFromUrl = populateTrackingObjectFromUrl;
var getTrackingObject = function (cookies) {
    var _a;
    if (cookies === void 0) { cookies = js_cookie_1.default.get(); }
    var rawObject = {};
    var gclid = undefined;
    var configuration = configuration_1.getConfiguration();
    try {
        rawObject = JSON.parse((_a = cookies === null || cookies === void 0 ? void 0 : cookies[configuration.featherInternalTrackingToolKey]) !== null && _a !== void 0 ? _a : '{}');
        gclid = cookies === null || cookies === void 0 ? void 0 : cookies['gclid'];
    }
    catch (_b) {
        // Something went bad on the cookie object when trying to deserialize it.
        // Most likely the cookie got manually changed.
        // Flushing the cookie object so that it doesn't happen again.
        exports.flushTrackingObject();
    }
    var trackingObject = {};
    utmParameter_1.allUtmParameterKeys.forEach(function (key) {
        var value = rawObject === null || rawObject === void 0 ? void 0 : rawObject[key];
        if (value) {
            trackingObject[key] = value;
        }
    });
    if (gclid) {
        trackingObject.gclid = gclid;
    }
    if (Object.keys(trackingObject).length === 0) {
        return undefined;
    }
    return trackingObject;
};
exports.getTrackingObject = getTrackingObject;
var flushTrackingObject = function () {
    var configuration = configuration_1.getConfiguration();
    js_cookie_1.default.remove(configuration.featherInternalTrackingToolKey, configuration.cookieAttributes);
};
exports.flushTrackingObject = flushTrackingObject;
